<template>
	<AnalysisChart
		endpoint="web/get-fcr-analysis"
		data-key="fcr"
		standard-key="standard_fcr"
		series-label="FCR"
		standard-label="Standard FCR"
		yaxis-title="Ratio"
	/>
</template>

<script>
import AnalysisChart from "../components/AnalysisChart.vue";

export default {
	components: { AnalysisChart },
};
</script>
